import { Typography } from '@mui/material'

interface FormFieldLabelProps {
    children: React.ReactNode
    required?: boolean
}

const FieldLabel = ({ required, children }: FormFieldLabelProps) => {
    return (
        <Typography data-test="field-label" sx={{ paddingLeft: '4px', fontWeight: 'bold' }}>
            {children}
            {required && <span style={{ color: 'rgba(0, 101, 173, 1)' }}>*</span>}
        </Typography>
    )
}

export default FieldLabel
